import styles from './FirstSection.module.css'
import State from '../../store/State';
import Modal from './Modal/Modal';
import { modal } from '../../types/enums';
import { observer } from 'mobx-react-lite';

export const FirstSection = observer(({ innerRef }: any) => {
  const canvasThreeClass = State.getModal() === modal.NO ? styles.inactive : State.getModalActive() ? styles.inactive : styles.active
  const textClass = State.getStep() > 0 ? styles.inactiveText : styles.activeText

  const onClickCountry = (): void => {
    if (State.getModal() !== modal.NO) {
      State.setModalActive(true)
    }
  }
  const loadingActive = State.getIsLoaded();
  return (
    <div className={styles.bg + ' ' + canvasThreeClass} onClick={onClickCountry}>
      <div className={styles.blur_right}></div>
      <div className={styles.blur_left}></div>
      <div ref={innerRef} className={styles.section} id='section1'>
        {loadingActive
          &&
          <>
            <p className={styles.title + ' ' + textClass}>НОВЫЙ МИР</p>
            <p className={styles.subtitle + ' ' + textClass}>Мир меняется, создавая новые возможности для сотрудничества и взаимопонимания. За этими переменами стоят люди, их идеи, достижения и общие проекты. Истории из разных уголков мира помогают увидеть, как сегодня выстраиваются связи между странами и какое место в этом мире занимает Россия.</p>
          </>
        }
      </div>

      <Modal />
      <div id='canvas_three' className={styles.canvas_three}></div>
    </div>
  )
});

export default FirstSection
